import React, { useState, useEffect } from 'react';
import { SolutionGrid, SolutionGridLayout, } from '@wix/app-market-collection-widget';
import { Origin, EditorType } from '../manage-installed-apps-page';
import { Loader, Box } from '@wix/design-system';
import { getRecommendationsFromML } from '../../api';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { v4 as generateUuidV4 } from 'uuid';
import { appMarketAppCollectionImpressions } from '@wix/bi-logger-app-market-data/v2';
export function RecommendedApps(props) {
    const { baseUrl, httpClient, locale, gotoWebSolutionPage, msid, origin, editorType, } = props;
    const biLogger = useBiLogger();
    const [isFetching, setIsFetching] = useState(true);
    const [solutions, setSolutions] = useState([]);
    const collimp_id = generateUuidV4();
    useEffect(() => {
        const fetchData = async () => {
            const apps = await getRecommendationsFromML(baseUrl, '4', locale, httpClient);
            if (apps) {
                const fetchedSolutions = apps.webSolutions.map(({ baseInfo }) => baseInfo);
                biLogger
                    .report(appMarketAppCollectionImpressions({
                    apps_list: fetchedSolutions
                        .map((webSolution) => webSolution.id)
                        .join(','),
                    collimp_id,
                    number_of_apps: 4,
                    tag_name: 'user-recommendations',
                    tag_type: 'manage_apps',
                    prediction_type: apps.predictionType,
                }))
                    .catch((e) => console.log(e));
                setSolutions(fetchedSolutions);
            }
        };
        fetchData().finally(() => setIsFetching(false));
    }, []);
    const biData = solutions
        ? solutions.map((solution, index) => ({
            msid,
            appId: solution.id,
            impressionType: 'box',
            index,
            market: origin === Origin.BIZMGR
                ? editorType === EditorType.ADI
                    ? 'adi_dashboard'
                    : 'dashboard'
                : origin,
            tagName: 'manage_apps',
            tagType: 'manage_apps',
            section: 'recommended_apps',
        }))
        : [];
    if (isFetching) {
        return (React.createElement(Box, { align: "center" },
            React.createElement(Loader, { size: "medium" })));
    }
    return (React.createElement(SolutionGrid, { solutions: solutions, solutionsBiData: biData, layout: SolutionGridLayout.INTEGRATIONS, locale: locale, colSpan: 4, numberOfLines: 1, editorType: editorType, onBoxClick: (app) => gotoWebSolutionPage(app.slug, 'manage_apps', collimp_id, 'manage-apps-user-recommendations') }));
}
//# sourceMappingURL=recommended-apps.js.map